import React from 'react';
import '../css/LegalPages.css';

const Kvkk = () => {
  return (
    <div className="legal-container">
      <h1>KVKK Aydınlatma Metni</h1>

      <section>
        <h3>1. Veri Sorumlusu</h3>
        <p>
          6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında,
          <strong>Halısahacım</strong> platformu üzerinden işlenen kişisel verilerinizin
          veri sorumlusu “Halısahacım” olarak tarafımızca işlenmektedir.
        </p>
      </section>

      <section>
        <h3>2. İşlenen Kişisel Veriler</h3>
        <p>Platformumuzda işlenen kişisel verileriniz şunlardır:</p>
        <ul>
          <li>Ad – Soyad</li>
          <li>Telefon numarası</li>
          <li>E-posta adresi</li>
          <li>Rezervasyon tarihleri ve işlem geçmişi</li>
          <li>Üyelik bilgileri (kullanıcı veya işletme)</li>
          <li>Profil bilgileri ve kullanıcı içerikleri</li>
          <li>Mesajlaşma kayıtları (kullanıcı–işletme iletişimi)</li>
          <li>IP adresi, cihaz bilgileri, çerez verileri</li>
        </ul>
      </section>

      <section>
        <h3>3. Kişisel Verilerin İşlenme Amaçları</h3>
        <p>Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
        <ul>
          <li>Üyelik oluşturma ve kullanıcı doğrulama</li>
          <li>Rezervasyon oluşturma ve yönetimi</li>
          <li>İşletmelerin panel yönetimi ve kullanıcılarla iletişimi</li>
          <li>Maç video yükleme ve erişim işlemleri</li>
          <li>Ödeme işlemlerinin yürütülmesi</li>
          <li>Sistem güvenliği, dolandırıcılık ve kötüye kullanımın önlenmesi</li>
          <li>Site performansının iyileştirilmesi</li>
          <li>Kullanıcılara bilgilendirme mesajlarının gönderilmesi</li>
        </ul>
      </section>

      <section>
        <h3>4. Kişisel Verilerin Aktarılması</h3>
        <p>
          Toplanan kişisel veriler sadece ilgili mevzuat ve hizmetin gereklilikleri
          doğrultusunda aşağıdaki kişi ve kuruluşlarla paylaşılabilir:
        </p>
        <ul>
          <li>Ödeme kuruluşları (İyzico vb.)</li>
          <li>Bulut depolama hizmet sağlayıcıları</li>
          <li>Hukuki zorunluluk halinde ilgili kamu kurumları</li>
          <li>Yetkili iş birliği partnerleri (sadece hizmet için gerekli olan veriler)</li>
        </ul>
        <p>Hiçbir veri üçüncü kişilere satılmaz veya ticari amaçla paylaşılmaz.</p>
      </section>

      <section>
        <h3>5. Kişisel Verilerin Toplama Yöntemi ve Hukuki Sebebi</h3>
        <p>
          Kişisel verileriniz; üyelik formu, iletişim sayfası, rezervasyon ekranı,
          cihaz bilgileri, çerezler ve mesajlaşma sistemi üzerinden tamamen dijital
          yollarla toplanmaktadır.
        </p>

        <p><strong>Hukuki sebepler:</strong></p>
        <ul>
          <li>KVKK m.5/2 – sözleşmenin kurulması ve ifası</li>
          <li>KVKK m.5/2 – hukuki yükümlülük</li>
          <li>KVKK m.5/2 – meşru menfaat</li>
          <li>Açık rıza gerektiren durumlarda kullanıcı onayı</li>
        </ul>
      </section>

      <section>
        <h3>6. Kişisel Verilerin Saklama Süresi</h3>
        <p>
          Kişisel verileriniz, ilgili mevzuatta belirtilen süreler boyunca saklanır.
          Herhangi bir yasal zorunluluk bulunmaması halinde, hesap silme talebi üzerine 
          verileriniz derhal sistemden kaldırılır.
        </p>
      </section>

      <section>
        <h3>7. KVKK Kapsamındaki Haklarınız</h3>
        <p>KVKK m.11 kapsamında aşağıdaki haklara sahipsiniz:</p>
        <ul>
          <li>Kişisel verinizin işlenip işlenmediğini öğrenme</li>
          <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
          <li>Amacına uygun kullanılıp kullanılmadığını öğrenme</li>
          <li>Yurt içinde veya dışında aktarılan kişileri bilme</li>
          <li>Eksik veya yanlış işlenen verilerin düzeltilmesini isteme</li>
          <li>Kişisel verilerinizin silinmesini veya yok edilmesini talep etme</li>
          <li>İşlemenin hukuka aykırı olması hâlinde zararın giderilmesini talep etme</li>
        </ul>
      </section>

      <section>
        <h3>8. Başvuru ve İletişim</h3>
        <p>
          KVKK kapsamındaki tüm talepleriniz için aşağıdaki adres üzerinden
          bizimle iletişime geçebilirsiniz:
        </p>
        <p>
          📧 <a href="mailto:halisahacim.com@gmail.com">halisahacim.com@gmail.com</a>
        </p>
      </section>
    </div>
  );
};

export default Kvkk;
